import { useState } from "react";
import TextField from "../../../designSystem/TextField";
import SingleSelect from "../../../designSystem/SingleSelect";
import "./Form.css";
import SaveButton from "../../../subComponents/buttons/SaveButton";
import BodySmallRegular from "../../../designSystem/BodySmallRegular";
import MultiSelect from "../../../designSystem/MultiSelect";
export default function Form({ fieldsConfig, onSubmit }) {
  const [formData, setFormData] = useState(
    fieldsConfig.reduce((acc, field) => {
      let defaultValue = field.default_value || ""; // Default fallback

      if (field.type === "multiselect" && !field.default_value) {
        defaultValue = []; // Ensure multi-select fields default to an empty array
      } else if (field.type === "checkbox" && !field.default_value) {
        defaultValue = false; // Ensure multi-select fields default to an empty array
      }
      return { ...acc, [field.name]: defaultValue };
    }, {})
  );

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    fieldsConfig.forEach((field) => {
      if (
        field.is_required &&
        field.type !== "checkbox" &&
        !formData[field.name]
      ) {
        newErrors[field.name] = `${field.name} is required`;
      }
      if (
        field.is_required &&
        field.type === "multiselect" &&
        formData[field.name].length === 0
      ) {
        newErrors[field.name] = `${field.name} is required`;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const handleChange = (e) => {
    if (e.target.type === "checkbox") {
      setFormData({
        ...formData,
        [e.target.name]:
          e.target.checked === undefined ? false : e.target.checked,
      });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    setErrors({ ...errors, [e.target.name]: "" }); // Clear error on change
  };

  const handleSelectChange = (option, label) => {
    setFormData({ ...formData, [label]: option.value });
    setErrors({ ...errors, [label]: "" }); // Clear error on change
  };
  const handleMultiSelectChange = (updatedValues, label) => {
    setFormData({ ...formData, [label]: updatedValues });
  };
  const handleSubmit = () => {
    if (!validateForm()) return; // Stop if validation fails

    const resultString = Object.entries(formData)
      .map(([key, value]) => `${key}: ${value}`)
      .join(", \n");

    console.log(resultString);
    if (onSubmit) onSubmit(resultString);
    setSubmitted(true);
  };

  return (
    <div className="form-card">
      <div className="fields-grid">
        {fieldsConfig.map((field, index) => (
          <div key={index}>
            {field.type === "select" ? (
              <>
                <SingleSelect
                  label={field.name}
                  onChange={handleSelectChange}
                  value={formData[field.name]}
                  options={field.data}
                  isSearchable={true}
                  disabled={submitted}
                  error={errors[field.name]}
                />
              </>
            ) : field.type === "checkbox" ? (
              <div style={{ display: "flex", justifyItems: "center" }}>
                <input
                  name={field.name}
                  style={{
                    cursor: "pointer",
                    height: "14px",
                    width: "14px",
                    accentColor: "#002D72", // ✅ This will change the checkbox color when checked
                  }}
                  type="checkbox"
                  checked={formData[field.name]}
                  className="ml-1 mt-1"
                  onChange={handleChange}
                  disabled={submitted}
                />
                <label
                  style={{ paddingLeft: "10px" }}
                  className="form-control-label"
                >
                  <BodySmallRegular text={field.name + "?"} color="#1E293B" />
                </label>
              </div>
            ) : field.type === "multiselect" ? (
              <>
                <MultiSelect
                  isSearchable
                  onChange={handleMultiSelectChange}
                  value={formData[field.name]}
                  label={field.name}
                  options={field.data}
                  error={errors[field.name]}
                />
              </>
            ) : (
              <>
                <TextField
                  label={field.name}
                  type={field.type || "text"}
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleChange}
                  disabled={submitted}
                  error={errors[field.name]}
                />
              </>
            )}
          </div>
        ))}
      </div>

      {!submitted && (
        <SaveButton
          onClick={handleSubmit}
          text="Submit"
          isLoading={false}
        />
      )}
    </div>
  );
}
